module.exports = __webpack_public_path__ + "img/logo-sync-exact.7218dda2.svg";